import { motion } from "framer-motion";
import { DraftingCompass, Scissors, Cog, ShieldCheck } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    icon: DraftingCompass,
    title: "Diseño bajo plano o muestra",
    text: "Replicamos la geometría original OEM a partir de tu plano técnico, o por levantamiento dimensional de la muestra física directo en tu planta.",
  },
  {
    num: "02",
    icon: Scissors,
    title: "Corte y doblez de precisión",
    text: "Lamelas en acero inoxidable cortadas y dobladas con tolerancias milimétricas para un desplazamiento suave y sin atascos.",
  },
  {
    num: "03",
    icon: Cog,
    title: "Pantógrafos y mecanismos",
    text: "Ensamble de pantógrafos, ruedas, amortiguadores y sistemas sincronizados dimensionados según la velocidad y recorrido de tu máquina.",
  },
  {
    num: "04",
    icon: ShieldCheck,
    title: "Componentes de desgaste",
    text: "Wipers CL1, guías de Nylamid y patines de latón integrados de fábrica para maximizar la vida útil desde el primer ciclo.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 44 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.12, duration: 0.8, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function FabricacionCapabilities() {
  return (
    <section
      id="capacidades"
      data-testid="fab-capabilities-section"
      className="gf-section bg-[#061226] relative"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-[#00B4D8]" />
            <span className="gf-overline">Capacidades de taller</span>
          </div>
          <h2 className="font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05] max-w-3xl">
            Fabricamos cada guarda{" "}
            <span className="text-[#00B4D8]">a la medida exacta.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-x-14">
          {CHAPTERS.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.article
                key={c.num}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-60px" }}
                data-testid={`fab-capability-${c.num}`}
                className="group border-t border-white/10 py-10 flex gap-7"
              >
                <span className="font-display font-black text-5xl lg:text-6xl leading-none gf-text-outline group-hover:text-[#00B4D8] group-hover:[-webkit-text-stroke:0px] transition-all duration-500 shrink-0">
                  {c.num}
                </span>
                <div>
                  <div className="flex items-center gap-3 mb-3">
                    <Icon size={17} className="text-[#00B4D8]" />
                    <h3 className="font-display font-bold text-white text-lg lg:text-xl tracking-tight">
                      {c.title}
                    </h3>
                  </div>
                  <p className="text-white/60 text-sm leading-relaxed">{c.text}</p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
